<template>
  <Modal v-model="showPickerModal" width="1024" :mask-closable="false"
    scrollable title="选择承保人" :z-index="900" @on-cancel="closePicker" @on-ok="closePicker">
    <div class="guarantor-list">
      <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
        <Panel name="filter" hide-arrow>
          <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
          <div class="pull-right">
            <Tooltip content="刷新结果">
              <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
            </Tooltip>
            <Divider type="vertical" />
            <Tooltip :content="expandText">
              <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
            </Tooltip>
          </div>
          <div slot="content">
            <div class="padding-top-20"></div>
            <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
              <Row :gutter="8">
                <i-col span="8">
                  <FormItem label="名称" prop="name">
                    <Input v-model="filterModel.name" placeholder="输入名称" />
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="社会信用代码" prop="businessLicense">
                    <Input v-model="filterModel.businessLicense" placeholder="输入社会信用代码" />
                  </FormItem>
                </i-col>
              </Row>
              <Row :gutter="8">
                <i-col span="8">
                  <FormItem label="类别" prop="type" style="width: 100%">
                    <Select v-model="filterModel.type" filterable style="width:200px">
                      <Option :value="null">不限</Option>
                      <Option v-for="(tp,idx) in $common.getEnumSelect($common.guarantorType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                    </Select>
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="状态" prop="type" style="width: 100%">
                    <Select v-model="filterModel.status" filterable style="width:200px">
                      <Option :value="null">不限</Option>
                      <Option v-for="(tp,idx) in $common.getEnumSelect($common.guarantorStatus)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                    </Select>
                  </FormItem>
                </i-col>
              </Row>
              <Row :gutter="8">
                <i-col span="8">
                  <FormItem label="联系人" prop="contact">
                    <Input v-model="filterModel.contact" placeholder="输入联系人" />
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="联系电话" prop="contactTel">
                    <Input v-model="filterModel.contactTel" placeholder="输入联系电话" />
                  </FormItem>
                </i-col>
              </Row>
              <Row :gutter="8">
                <i-col span="16">
                  <FormItem style="width: 100%; text-align:right">
                    <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                    <Divider type="vertical" />
                    <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                  </FormItem>
                </i-col>
              </Row>
            </Form>
          </div>
        </Panel>
      </Collapse>
      <div class="padding-top-10"></div>
      <div class="padding-top-10"></div>
      <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
      <Table border ref="dataTable"
        size="small"
        stripe
        :columns="columns"
        @on-sort-change="tableSortChange"
        @on-selection-change="selectionChange"
        :data="data">
      </Table>
      <Page class="pager"
        :total="totalCount"
        :current="currentPageIndex"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
        size="small"
        show-elevator
        show-total
        show-sizer />
    </div>
    <div slot="footer">
      <Button size="large" @click="closePicker">取消</Button>
      <Button type="primary" :disabled="!selectedItems||!selectedItems.length" size="large" @click="assignToGuarantor()">分发试卷({{ selectedItems.length }})</Button>
  </div>
  </Modal>
</template>

<script>
export default {
  name: 'guarantor-picker',
  props: {
    show: Boolean,
    paperId: String
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          type: 'selection',
          width: 60
        },
        {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '社会信用代码',
          key: 'businessLicense',
          resizable: true,
          width: 200,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '状态',
          key: 'status',
          width: 120,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: this.$common.guarantorStatusColor[params.row.status.toString()]
              }
            }, this.$common.guarantorStatus[params.row.status.toString()])
          }
        },
        {
          title: '类型',
          key: 'type',
          width: 120,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.$common.guarantorType[params.row.type.toString()])
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '分发试卷',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-paper-plane'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.assignToGuarantor(params.row.id)
                    }
                  }
                }, null)
              ]),
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        name: null,
        businessLicense: null,
        type: null,
        status: null,
        contact: null,
        contactTel: null
      },
      departments: [],
      curDepartmentId: null,
      showPickerModal: false,
      selectedItems: [],
    }
  },
  watch: {
    show: function (newVal) {
      if (newVal) {
        this.initData()
        this.showPickerModal = true
      }
    },
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  computed: {
    expandText () {
      return (this.tableToolsPanel.indexOf('filter') > -1 ? '隐藏' : '展开') + '筛选条件'
    }
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    selectionChange (selection) {
      this.selectedItems = selection
    },
    closePicker () {
      console.log('closepicker')
      this.showPickerModal = false
      this.$nextTick(() => {
        this.$emit('close-picker')
      })
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Guarantor.listGuarantors(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.data = res.data
      this.$Spin.hide()
    },
    async assignToGuarantor (tId) {
      if (!tId && (!this.selectedItems || !this.selectedItems.length)) {
        this.$Message.error('请选择分发对象')
        return false
      }
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认分发试卷到该选定的对象么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Appraisal.assignAppraisalPaper({
            paperId: this.paperId,
            guarantorIds: tId ? [tId] : this.selectedItems.map(s => {return s.id})
          }).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
        },
        onCancel: () => {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
